var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.098,22.138H34.306c-4.036,0-7.319,3.284-7.319,7.32V67.31c0,4.036,3.283,7.319,7.319,7.319h30.792c1.104,0,2-0.896,2-2 s-0.896-2-2-2H34.306c-1.83,0-3.319-1.489-3.319-3.319c0-1.831,1.489-3.32,3.319-3.32h30.792c1.104,0,2-0.896,2-2V24.138 C67.098,23.034,66.202,22.138,65.098,22.138z M63.098,59.989H34.306c-1.196,0-2.322,0.294-3.319,0.804V29.458 c0-1.831,1.489-3.32,3.319-3.32h28.792V59.989z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.098,65.31H34.306c-1.104,0-2,0.896-2,2s0.896,2,2,2h30.792c1.104,0,2-0.896,2-2S66.202,65.31,65.098,65.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,54.118c-1.308,0-2.371-1.063-2.371-2.371c0-1.104-0.896-2-2-2s-2,0.896-2,2c0,3.513,2.858,6.371,6.371,6.371 c3.513,0,6.371-2.858,6.371-6.371c0-1.692-0.668-3.229-1.748-4.371c1.08-1.142,1.748-2.679,1.748-4.371 c0-3.513-2.858-6.371-6.371-6.371c-1.308,0-2.371-1.063-2.371-2.371s1.063-2.371,2.371-2.371s2.371,1.063,2.371,2.371 c0,1.104,0.896,2,2,2s2-0.896,2-2c0-3.513-2.858-6.371-6.371-6.371c-3.513,0-6.371,2.858-6.371,6.371 c0,1.693,0.668,3.229,1.748,4.371c-1.08,1.142-1.748,2.678-1.748,4.371c0,3.513,2.858,6.372,6.371,6.372c0.002,0,0.004,0,0.006,0 c1.305,0.004,2.365,1.065,2.365,2.37C50.371,53.055,49.308,54.118,48,54.118z M48,40.635c1.308,0,2.371,1.063,2.371,2.371 c0,1.308-1.063,2.371-2.371,2.371s-2.371-1.063-2.371-2.371C45.629,41.698,46.692,40.635,48,40.635z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaw);
export default __webpack_public_path__ + "static/media/law.7209fe7f61c33952773a7b0663a44834.svg";
export { ForwardRef as ReactComponent };